(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const tSplide = document.querySelectorAll('.trusler-block--logo-slider .splide');

		tSplide.forEach(sliderEl => {

			const splide = new Splide(sliderEl, {
				perPage: 3,
				perMove: 3,
				arrows: true,
				pagination: false,
				autoplay: false,				
				type: 'slide',
				rewind: true,
				gap: 0,
				mediaQuery: 'max',
				breakpoints: {
					992: {
						arrows: true,						
						perPage: 2,
						perMove: 1
					},
					768: {
						perPage: 1,
						perMove: 1
					},			
				}
			});

			splide.on('mounted resize', () => {

				const totalSlides 	= splide.Components.Elements.slides.length,
      				  window_width 	= $(window).width(),
      				  noArrows 		= totalSlides < 4 && window_width > 992;

      			//console.log(noArrows);

				$(sliderEl).toggleClass( 'no-arrows', noArrows );				


			})
	
			splide.mount();

		});

		const logoBlocksArr = document.querySelectorAll('.trusler-block--logo-slider');

		logoBlocksArr.forEach(block => {

			ParcelFunctions.inViewport(block, 0.05, 0.15, 'block-in-viewport');

		});

	});

})(jQuery);